module.exports = __webpack_public_path__ + "img/red_043.75fce567.png";